<template lang="pug">
v-layout.menu
  v-flex(lg12, md12, xs12)
    v-card
      f-transaction-list-stepper(
        :productId="productId",
        :productGroup="productGroup",
        :transactionForm="transactionForm"
      )
</template>
<script>
export default {
  name: "FTransactionListCard",
  props: ["productId", "productGroup", "transactionForm"],
};
</script>